import { render, staticRenderFns } from "./select-members-tags.vue?vue&type=template&id=63483ea2&"
import script from "./select-members-tags.vue?vue&type=script&lang=js&"
export * from "./select-members-tags.vue?vue&type=script&lang=js&"
import style0 from "./select-members-tags.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports